import { useParams } from 'react-router';
export const useStructuralId = () => {
    const { structuralId } = useParams();
    if (structuralId == null) {
        throw new Error(`useStructuralId called with invalid :structuralId (${structuralId})`);
    }
    return structuralId;
};
